import { CustomSessionStorage } from '@/lib/storage/customSessionStorage';

const KEY = 'gmo-transfer-test';

export const gmoTestStorage = CustomSessionStorage<string>(KEY);

export interface PaypayConnectionParam {
  [key: string]: string;
  /** 委託者コード：SEC_ID10：数字(半角)：10桁 */
  SEC_ID10: string;
  /** セッションID：SESID：数字、英大文字(半角)：16桁 */
  SESID: string;
  /** PPB店番号：JNBBR：数字(半角)：3桁 */
  JNBBR: string;
  /** PPB口座番号：JNBAC：数字(半角)：7桁 */
  JNBAC: string;
  /** 口振申込日：PRODATE：数字(半角)：8桁（YYYYMMDD） */
  PRODATE: string;
  /** 契約者姓(漢字)：CUST_NAME1_K：漢字、カナ、ひらがな(全角)：30桁 */
  CUST_NAME1_K: string;
  /** 契約者名(漢字)：CUST_NAME2_K：漢字、カナ、ひらがな(全角)：30桁 */
  CUST_NAME2_K: string;
  /** 契約者姓(カナ)：CUST_NAME1：カナ(全角)：48桁 */
  CUST_NAME1: string;
  /** 契約者名(カナ)：CUST_NAME2：カナ(全角)：48桁 */
  CUST_NAME2: string;
  /** 生年月日：BD：数字(半角)：8桁（YYYYMMDD） */
  BD: string;
  /** その他：COMMENT：一部使用制限文字有り：（桁数なし）桁 */
  COMMENT: string;
  /** お客さま番号1：ACCOUNT1：数字、英字、記号：50桁 */
  ACCOUNT1: string;
}

export interface PaypayConnectionResult {
  /** 委託者コード：SEC_ID10：数字(半角)：10桁 */
  SEC_ID10: string;
  /** セッションID：SESID：数字、英大文字(半角)：16桁 */
  SESID: string;
  /** PPB店番号：JNBBR：数字(半角)：3桁 */
  JNBBR: string;
  /** PPB口座番号：JNBAC：数字(半角)：7桁 */
  JNBAC: string;
  /** 口振申込日：PRODATE：数字(半角)：8桁（YYYYMMDD） */
  PRODATE: string;
  /** 契約者姓(漢字)：CUST_NAME1_K：漢字、カナ、ひらがな(全角)：30桁 */
  CUST_NAME1_K: string;
  /** 契約者名(漢字)：CUST_NAME2_K：漢字、カナ、ひらがな(全角)：30桁 */
  CUST_NAME2_K: string;
  /** 契約者姓(カナ)：CUST_NAME1：カナ(全角)：48桁 */
  CUST_NAME1: string;
  /** 契約者名(カナ)：CUST_NAME2：カナ(全角)：48桁 */
  CUST_NAME2: string;
  /** 生年月日：BD：数字(半角)：8桁（YYYYMMDD） */
  BD: string;
  /** 性別：SEX：数字(半角)：1桁（1:男性、2:女性、9:その他） */
  SEX: string;
  /** 電話番号(市外局番)：TEL1：数字(半角)：17桁 */
  TEL1: string;
  /** 電話番号(局番)：TEL2：数字(半角)：17桁 */
  TEL2: string;
  /** 電話番号(番号)：TEL3：数字(半角)：17桁 */
  TEL3: string;
  /** 郵便番号：ZIPNO：数字(半角)：7桁 */
  ZIPNO: string;
  /** 都道府県：PREF：漢字(全角)：4桁 */
  PREF: string;
  /** 住所：ADDR：Various(全角)：20桁 */
  ADDR: string;
  /** 補助住所：ADDR2：Various(全角)：20桁 */
  ADDR2: string;
  /** メールアドレス：MAIL：数字、英字、記号(半角)：50桁 */
  MAIL: string;
  /** その他：COMMENT：一部使用制限文字有り：（桁数なし）桁 */
  COMMENT: string;
  /** お客さま番号1：ACCOUNT1：数字、英字、記号：50桁 */
  ACCOUNT1: string;
  /** お客さま番号2：ACCOUNT2：数字、英字、記号：50桁 */
  ACCOUNT2: string;
  /** お客さま番号3：ACCOUNT3：数字、英字、記号：50桁 */
  ACCOUNT3: string;
  /** お客さま番号4：ACCOUNT4：数字、英字、記号：50桁 */
  ACCOUNT4: string;
  /** お客さま番号5：ACCOUNT5：数字、英字、記号：50桁 */
  ACCOUNT5: string;
  /** お客さま番号6：ACCOUNT6：数字、英字、記号：50桁 */
  ACCOUNT6: string;
  /** お客さま番号7：ACCOUNT7：数字、英字、記号：50桁 */
  ACCOUNT7: string;
  /** 委託者支店名：NS_BTN：Various(全角)：25桁 */
  NS_BTN: string;
  /** Signature（署名）：RE_SESID2：数字(半角)：16桁 */
  RE_SESID2: string;
  /** 処理結果(ステータス)：STATUS：数字(半角)：1桁（1:OK、2:NG） */
  STATUS: string;
  /** 契約日：CONT_YMD：数字(半角)：8桁（YYYYMMDD） */
  CONT_YMD: string;
  /** 契約時刻：CONT_HMS：数字(半角)：6桁（hhmmss） */
  CONT_HMS: string;
  /** チェック文字列：VALIDATION：数字、英大文字(半角)：64桁 */
  VALIDATION: string;
}

const KEY_PAYPAY_RESULT = 'paypay-result';
const KEY_PAYPAY_ACCOUNT = 'paypay-account';

/** ペイペイ口座連携結果 */
export const paypayResultStorage =
  CustomSessionStorage<boolean>(KEY_PAYPAY_RESULT);

/** ペイペイ口座番号` */
export const paypayAccountStorage =
  CustomSessionStorage<string>(KEY_PAYPAY_ACCOUNT);
